import { render, staticRenderFns } from "./product-period-page.vue?vue&type=template&id=8eae6998&scoped=true&"
import script from "./product-period-page.vue?vue&type=script&lang=js&"
export * from "./product-period-page.vue?vue&type=script&lang=js&"
import style0 from "./product-period-page.vue?vue&type=style&index=0&id=8eae6998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eae6998",
  null
  
)

export default component.exports